/**
 * 教师中心 - 试卷编辑页面
 * 
 * 直接复用后台PaperEditor组件，通过isTeacherMode参数实现数据隔离
 */

import PaperEditor from '../admin/PaperEditor';

export default function TeacherPaperEditor() {
  return <PaperEditor isTeacherMode={true} />;
}
